<!--
 * @Author: Jason
 * @Date: 2019-10-15 17:32:50
 * @version: 
 * @LastEditors: Jason
 * @LastEditTime: 2019-10-29 14:34:33
 * @Descripttion: 
 -->
<template>
  <div>
    <v-head :isShowBack="$route.meta.isShowIcon">个人中心</v-head>

    <div class="mt">
      <div class="flex-btwn-aic person-info">
        <div class="person-info-tel">
          <div class="person-info-title">欢迎您！</div>
          <div>{{userInfo.telephone | phoneHidden}}</div>
        </div>
        <img src="../assets/imgs/icon_person_avator.png" alt />
      </div>
      <div class="person-opo-list">
        <!-- <div class="flex-btwn-aic person-opo-item" @click="toRouter('/order')">
          <div>我的订单</div>
          <div class="color-gree">查看全部订单</div>
        </div>-->
        <div class="flex-btwn-aic person-opo-item mt-20" @click="toTel()">
          <div class="flex-aic">
            <img class="person-tel" src="../assets/imgs/icon_person_tel.png" alt /> 咨询服务
          </div>
          <div class="color-gree">4008881768</div>
        </div>
      </div>
    </div>

    <div class="footer-btn" @click="loginOut()">退出登录</div>
    <transition name="fade">
      <div class="flex-jcc-aic mask" v-show="isShowMsg">
        <msg okText="退出" noText="我再想想" @close="closeMsg()" @confirm="confirmMsg()">
          <div class="loginout-tip">是否退出登录？</div>
        </msg>
      </div>
    </transition>
  </div>
</template>

<script>
import msg from "@/components/messageBox.vue";
import { GetUserInfo } from "@/api/user.js";
import { ls } from "@/assets/js/utils.js";
import vHead from "@/components/vHead.vue";
export default {
  name: "personal",
  components: {
    vHead,
    msg
  },
  data() {
    return {
      userInfo: {},
      isShowMsg: false
    };
  },

  created() {
    let _ = this;
    document.body.style.backgroundColor = "#F4F5F7";
    if (ls.getter("loginStatus")) {
      _.getUserInfo();
    }
  },
  methods: {
    getUserInfo() {
      let _ = this;
      GetUserInfo({ token: ls.getter("loginStatus") })
        .then(res => {
          _.userInfo = res;
          console.log("userInfo=======>", _.userInfo);
        })
        .catch(err => {
          if (err && err.resultDes) {
            _.toast(err.resultDes);
          }
        });
    },
    toTel() {
      location.href = "tel:4008881768";
    },
    loginOut() {
      let _ = this;
      _.isShowMsg = true;
      // ls.del('loginStatus')
    },
    closeMsg() {
      let _ = this;
      _.isShowMsg = false;
    },
    confirmMsg() {
      let _ = this;
      ls.del("loginStatus");
      _.isShowMsg = false;
      _.$router.replace("/home");
    },
    toRouter(val) {
      let _ = this;
      _.$router.push(val);
    }
  }
};
</script>

<style lang="scss" scoped>
.person-tel {
  width: 4.2667vw;
  height: auto;
  margin-right: 2vw;
  display: inline-block;
}
.loginout-tip {
  text-align: center;
  font-size: 4vw;
}

.person-opo-list {
  // margin-top: 8vw;

  .person-opo-item {
    padding: 0 4vw;
    height: 13.3333vw;
    font-size: 4vw;
    background-color: #fff;
  }
}
.person-info {
  width: 100%;
  height: 28vw;
  padding: 0 4vw;
  background: linear-gradient(
    -90deg,
    rgba(247, 190, 137, 1),
    rgba(254, 221, 190, 1)
  );
  background: -ms-linear-gradient(
    -90deg,
    rgba(247, 190, 137, 1),
    rgba(254, 221, 190, 1)
  );
  background: -moz-linear-gradient(
    -90deg,
    rgba(247, 190, 137, 1),
    rgba(254, 221, 190, 1)
  );
  background: -webkit-linear-gradient(
    -90deg,
    rgba(247, 190, 137, 1),
    rgba(254, 221, 190, 1)
  );
  // background:linear-gradient(-90deg,rgba(247,190,137,1),rgba(254,221,190,1));
  img {
    width: 15.6vw;
    height: 15.6vw;
  }
  .person-info-tel {
    font-size: 4vw;
    .person-info-title {
      margin-bottom: 2vw;
    }
  }
}
</style>


